import React from 'react'
import Ink from 'react-ink';
import { connect } from 'react-redux'
import { setCurrentObjectGroup } from '../actions/objectManagementActions.js'
import * as types from '../../constants/Types'
import PropTypes from 'prop-types'

class MenuButton extends React.Component {
  constructor(props) {
    super(props)
    this.handleTouchTap = this.handleTouchTap.bind(this);
  }

  handleTouchTap() {
    this.props.setCurrentObjectGroup(this.props.id);
  }
  
  componentWillUnmount() {
    if(this.props.postype === types.POSTYPE_PRODUCTIONKIOSK) {
      clearInterval(this.interval);
    }
  };

  render() {
    const {
      postype,
      processed,
      text
    } = this.props;

    let buttonClassName = 'om_menubutton';    
    if(postype === types.POSTYPE_PRODUCTIONKIOSK && !processed) {
      buttonClassName += '  blinkObjectManagementMenuButton';
    }

    return (
      <button className={buttonClassName} onClick={this.handleTouchTap}>
        {text}
        <Ink />
      </button>)
  }
}

MenuButton.propTypes = {
  text: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  setCurrentObjectGroup: PropTypes.func.isRequired
}

function mapStateToProps(state) {
  return {
    postype: state.generalState.posType,
    posid: state.generalState.posId
  }
}

export default connect(mapStateToProps, { 
  setCurrentObjectGroup 
})(MenuButton)



// WEBPACK FOOTER //
// src/objectmanagement/components/MenuButton.jsx